var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 16.0897H13.4167L14.75 10.7563H10.0833V8.08968C10.0833 6.71635 10.0833 5.42301 12.75 5.42301H14.75V0.943014C14.3153 0.885681 12.674 0.756348 10.9407 0.756348C7.32067 0.756348 4.75 2.96568 4.75 7.02301V10.7563H0.75V16.0897H4.75V27.423H10.0833V16.0897Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.3d152ed63859ed4145db3134f0517f1c.svg";
export { ForwardRef as ReactComponent };